import React, { memo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Link, Button } from '@beef/ui-kit';

// Styles
import styles from '../../styles.pcss';
const cn = classNames.bind(styles);

export const ButtonsBlock = memo(({ buttons, onClose }) => (
  <div className={cn('error__group')}>
    {buttons?.map((buttonItem, idx) => {
      const { text, url, id } = buttonItem;
      return id === 'CONFIRM' ? (
        <Button key={idx} size="m" variant="main" onClick={onClose}>
          {text}
        </Button>
      ) : (
        <Link
          href={url}
          key={idx}
          buttonSize="m"
          buttonVariant={(idx % 2 === 0) ? 'main' : 'tertiary'}
          isFullWidth={false}
          size="size4-r"
          variant="button"
        >
          {text}
        </Link>
      );
    })}
  </div>
));

ButtonsBlock.propTypes = {
  onClose: PropTypes.func,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    text: PropTypes.string,
  })),
};
